import { CLASS_NAME_PREFIX } from "../__config__/constants";

export const ToastClassName = `${CLASS_NAME_PREFIX}-toast`;
export const ToastbodyClassName = `${ToastClassName}__body`;
